import { render, staticRenderFns } from "./InfoTable.vue?vue&type=template&id=fa75b5be&"
import script from "./InfoTable.vue?vue&type=script&lang=js&"
export * from "./InfoTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports